<div
  #origin
  class="flex h-9 min-w-0 items-center rounded-lg border bg-white text-sm transition"
  [ngClass]="disabled ? '!border-slate-100 bg-slate-50' : '!border-slate-200 focus-within:!border-orange-400'"
>
  <span class="grid h-full w-9 shrink-0 place-items-center text-slate-400">
    <app-icon class="!h-[18px] !w-[18px] !text-[18px] !leading-none">add_shopping_cart</app-icon>
  </span>
  <input
    #searchInput
    type="text"
    class="h-full min-w-0 flex-1 !border-0 bg-transparent !p-0 pr-2 text-sm text-slate-800 outline-none placeholder:text-slate-400 disabled:cursor-not-allowed"
    autocomplete="off"
    [disabled]="disabled"
    [ngModel]="query"
    (ngModelChange)="onQueryChange($event)"
    (focus)="open = !!query.trim()"
    (keydown)="onKeydown($event)"
    [placeholder]="placeholder || ('stock.variant_picker_placeholder' | translate)"
  />
  @if (searching) {
    <span class="grid h-full w-9 shrink-0 place-items-center">
      <span class="h-4 w-4 animate-spin rounded-full border-2 !border-slate-200 border-t-orange-500"></span>
    </span>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayWidth]="overlayWidth"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  (overlayOutsideClick)="onOutsideClick($event)"
  (detach)="open = false"
>
  <div class="crm-scroll max-h-80 overflow-y-auto rounded-lg border !border-slate-200 bg-white py-1 shadow-lg">
    @if (searching && !results.length) {
      <div class="flex h-12 items-center justify-center">
        <app-loader type="indeterminate" />
      </div>
    } @else {
      @for (result of results; track result.id; let index = $index) {
        <button
          type="button"
          class="flex w-full min-w-0 items-center gap-3 px-3 py-2 text-left transition"
          [ngClass]="index === activeIndex ? 'bg-orange-50' : 'hover:bg-slate-50'"
          (mousedown)="$event.preventDefault()"
          (mouseenter)="activeIndex = index"
          (click)="pick(result)"
        >
          <app-warehouse-thumb [fileId]="result.photo_id" size="sm" />
          <span class="min-w-0 flex-1">
            <span class="block truncate text-sm font-medium text-slate-900">
              {{ result.product_name }}
              @if (result.name) {
                <span class="font-normal text-slate-500">· {{ result.name }}</span>
              }
            </span>
            <span class="block truncate text-xs text-slate-500">
              {{ getVariantCodes(result) || ('stock.no_sku' | translate) }}
            </span>
          </span>
          <span class="flex shrink-0 flex-col items-end gap-0.5">
            <span class="text-sm font-semibold text-slate-800">
              {{ formatMoneyAmount(result.price, result.currency) }}
            </span>
            <span class="text-xs" [ngClass]="result.stock.available > 0 ? 'text-emerald-600' : 'text-slate-400'">
              {{ 'stock.available_short' | translate }}: {{ formatQuantity(result.stock.available) }}
              {{ result.unit }}
            </span>
          </span>
          @if (isSelected(result)) {
            <app-icon class="!h-4 !w-4 shrink-0 !text-[16px] !leading-none text-emerald-500">check_circle</app-icon>
          }
        </button>
      } @empty {
        <div class="px-3 py-3 text-center text-sm text-slate-500">{{ 'stock.nothing_found' | translate }}</div>
      }
    }
  </div>
</ng-template>
